// extracted by mini-css-extract-plugin
export var activateCardBtn = "components-account-card-activate-card-__ActivateCard-module___activateCardBtn";
export var activateCardContainer = "components-account-card-activate-card-__ActivateCard-module___activateCardContainer";
export var paragraph = "components-account-card-activate-card-__ActivateCard-module___paragraph";
export var renameCardInput = "components-account-card-activate-card-__ActivateCard-module___renameCardInput";